module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!-- Delete confirmation modal -->\r\n<div class="modal fade" id="delete-confirmation-modal" tabindex="-1" role="dialog">\r\n    <div class="modal-dialog">\r\n\r\n        <div class="modal-content">\r\n            <div class="modal-header">\r\n                <button type="button" class="close" data-dismiss="modal">&times;</button>\r\n                <h4 class="modal-title">'+
((__t=( title ))==null?'':__t)+
'</h4>\r\n            </div>\r\n            <div class="modal-body">\r\n                <p>'+
((__t=( message ))==null?'':__t)+
'</p>\r\n                <input class="form-control" type="text" placeholder="'+
((__t=( confirmationAnswer ))==null?'':__t)+
'" id="confirmation"/>\r\n            </div>\r\n            <div class="modal-footer">\r\n                <button type="button" class="btn btn-danger" id="remove">Delete</button>\r\n                <button type="button" class="btn btn-default" id="close" data-dismiss="modal">Close</button>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/common/delete-confirmation-modal.html
// module id = 242
// module chunks = 0